import { QueryFilterParameter } from './../../../widgets/filters/models/query-filter-parameter.model';
import { HelpService } from './../../help/help.service';
import { Title } from '@angular/platform-browser';
import { DxChartComponent, DxDataGridComponent, DxPieChartComponent } from "devextreme-angular";
import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { EsoService, DecisionTreeManualDto, StockChartData } from "../eso.service";
import {
	OverviewFiltersOutput,
	StockService,
} from "../../stock/stock.service";
import { DevTooltipCustComponent } from "src/app/widgets";
import { registerPalette, currentPalette } from "devextreme/viz/palette";
import { ActivatedRoute, Data } from "@angular/router";
import { NotificationService } from "src/app/services/notification.service";
import { LoadService } from "src/app/services/load.service";
import { SelectionElement, SettingsService } from "../../settings/settings.service";
import { WindowService } from "src/app/services/window.service";
import { InfoBoxService } from "src/app/services/info-box.service";
import { ShareDataService } from 'src/app/services/share-data.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { TaskService } from '../../task/task.service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { TableDataOperator } from 'src/app/operators/table-data.operator';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { UtilsService } from 'src/app/services/utils.service';

const ESO_TARGET_SERVICE_LEVEL_LIST_ID = "21";

@Component({
	templateUrl: "./overview.component.html",
	styleUrls: ["./overview.component.scss"],
	standalone: false
})
export class OverviewComponent implements OnInit {
	private _editableColumns: { [key: string]: string } = {
		ServiceLevelManual: "string",
		SafetyStockManual: "number",
		Comment: "string",
	};

	compactMode = false;
	hasDirty = false;
	EsoOverviewDeepDiveDecimalPlace: number = 0;
	targetServiceLevelData: string[] = [];

	filterOptions: OverviewFiltersOutput;

	@ViewChild("stockValueChart", { static: false })
	dxStockValueChart: DxChartComponent;

	@ViewChild("changeCountChart", { static: false })
	changeCount: DxPieChartComponent;

	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;


	changeCountChartData: { changeCategory: string; count: number }[] = [];
	stockValueChartData: any[] = [];
	gridColumns: { columnName: string; caption: string; dataType: string }[] = [];
	gridData: {
		IsDirty: boolean;
		ProductId: string;
		[key: string]: string | number | boolean;
	}[] = [];
	route: any;
	action: string;
	taskFilterData: any;
	IsTaskLoad: boolean;
	gridState: any;
	dataLoaded = false;

	gridMinWidthSetting = 0;

	gridFilterState: any;
	headerFiltersState: any = {};
	filterRowState: {};
	sortOrderState: any;

	//public StockChartDataOperator: TableDataOperator<StockChartData> = new TableDataOperator();
	//Filters
	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.EsoOverviewGridData,
				selectionSetId: SelectionSetId.EsoOverviewFilters,
			}
		)
	);
	//EsoOverviewGridData
	public EsoOverviewGridDataOperator: TableDataOperator = new TableDataOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,
				baseSelectStatementId: BaseSelectStatementId.EsoOverviewGridData,
				selectionSetId: SelectionSetId.EsoOverviewList,
			}
		)
	);
	//changeCountChartData

	public ChartDataOperator: TableDataOperator = new TableDataOperator(
		new SelectStatementOptions(
			{

				filters: async () => this.pageFiltersOperator.appliedFilters,
				baseSelectStatementId: BaseSelectStatementId.EsoOverviewChangeCountChart,
				selectionSetId: null,
			}
		)
	);

	//StockChartData

	public StockChartDataOperator: TableDataOperator = new TableDataOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,
				baseSelectStatementId: BaseSelectStatementId.EsoOverviewStockValueChart,
				selectionSetId: null,
			}
		)
	);
	//Bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			)
		];

		return routeData;
	}

	constructor(
		private esoService: EsoService,
		private notificationService: NotificationService,
		private loadService: LoadService,
		private stockService: StockService,
		private windowService: WindowService,
		private infoBoxService: InfoBoxService,
		private titleService: Title, private settingsService: SettingsService,
		private helpService: HelpService, private shareDataService: ShareDataService,
		private routeMap: ActivatedRoute, private taskServiceNew: TaskService
		, private fileExportService: FileExportService, private tableParamService: TableParameterService
	) { this.shareDataService.CleanData(); }


	async ngOnInit() {
		registerPalette(
			"customPalette",
			{
				simpleSet: ["#4472C4", "#3B64AD", "#BAC4E2", "#315493", "#8CA0D3"], // Applies in the BarGauge, Chart, Funnel, PieChart, PolarChart, Sankey, and TreeMap with a discrete colorizer.
				indicatingSet: ["#4472C4", "#8CA0D3", "#BAC4E2"], // Applies in the CircularGauge and LinearGauge.
				gradientSet: ["#3B64AD", "#8CA0D3"], // Applies in the VectorMap and TreeMap with a gradient or range colorizer.
			}
		);
		currentPalette("customPalette");

		this.titleService.setTitle("Eso Overview");
		this.routeMap.paramMap.subscribe(
			params => {
				const value = this.routeMap.snapshot.queryParamMap.get("taskid");
				if (value) {
					this.taskServiceNew.SelectTaskFilterValues(value).subscribe(data => {
						this.taskFilterData = data;
						this.taskFilterData.forEach(
							(_) => {

							}
						);
						this.pageFiltersOperator.load(
							{
								showLoadingIndicator: true,
							}
						);
						this.loadPageData();
						this.onResize();
						this.loadLengendToShare();
						this.getData()
						// this.EsoOverviewGridDataOperator.load(
						// 	{
						// 		showLoadingIndicator: true
						// 	}
						// );
						this.ChartDataOperator.load(
							{
								showLoadingIndicator: true
							}
						);
						// this.StockChartDataOperator.load(
						// 	{
						// 		showLoadingIndicator: true
						// 	}
						// );
						console.log('********ChartDataOperator', this.ChartDataOperator.selectStatementResult?.data);

					}, err => {

					});

				}
			});

		this.GetSettingsData();
		this.WebSettingsPivot();
		this.SettingsGroupByName();
		this.settingsService.getGeneralSettings().subscribe(res => {
			let colWidth = res.settings.find(x => x.name == 'Grid Minimum Column Width');
			if (colWidth) {
				this.gridMinWidthSetting = +colWidth.value;
			}
		});
		this.LoadDataDefault();
		await this.initializeBookmarks();
		this.loadPageData();
		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(selection) => {
				this.shareDataService.CleanData();
				this.shareDataService.filterOptionOverview = selection.output;
				this.pageFiltersOperator.load(
					{
						showLoadingIndicator: true,
					}
				);
				this.onResize();
				this.loadLengendToShare();
				this.getData()
				// this.EsoOverviewGridDataOperator.load(
				// 	{
				// 		showLoadingIndicator: true
				// 	}
				// );
				this.ChartDataOperator.load(
					{
						showLoadingIndicator: true
					}
				);
				// this.StockChartDataOperator.load(
				// 	{
				// 		showLoadingIndicator: true
				// 	}
				// )


				this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.shareDataService.filterOptionOverview.filters);
			}
		);
		// const stockData = this.StockChartDataOperator.selectStatementResult.columns
		// // const transformedArray = Object.entries(stockData).map(([key, value]) => ({   name: key,   value: value })); console.log(transformedArray);
		// console.log('********ChartDataOperator1',stockData);
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.onResize();
						this.loadLengendToShare();
						this.getData();
						// this.EsoOverviewGridDataOperator.load(
						// 	{
						// 		showLoadingIndicator: true,
						// 	}
						// );
						this.ChartDataOperator.load(
							{
								showLoadingIndicator: true
							}
						);
						// this.StockChartDataOperator.load(
						// 	{
						// 		showLoadingIndicator: true
						// 	}
						// ).then(() => {
						// 	if (this.StockChartDataOperator.selectStatementResult?.data) {
						// 		console.log('StockChartDataOperator data:', this.StockChartDataOperator);
						// 	} else {
						// 		console.log('StockChartDataOperator Pagedata is undefined');
						// 	}
						// });
					}
				}
			}
		);
	}

	loadGridState = () => {
		if (localStorage.getItem("eso-overview-storage") && this.dataGrid) {
			this.gridState = JSON.parse(localStorage.getItem("eso-overview-storage"));
			this.dataGrid.instance.state(this.gridState);
		}
	}

	saveGridState = (newState) => {
		if (!this.dataLoaded) {
			this.gridState = newState;
			// Saves the state in the local storage
			localStorage.setItem("eso-overview-storage", JSON.stringify(newState));
		}
	}

	SettingDecimal: any;
	SettingsGroupByName() {
		this.settingsService.SettingsGroupByName("FcDeepDive", "EsoCurrencyField").subscribe(result => {
			this.SettingDecimal = result.table;
		});
	}

	LoadDataDefault() {
		this.stockService
			.getDeepDiveDropdownData(ESO_TARGET_SERVICE_LEVEL_LIST_ID)
			.subscribe((res: SelectionElement[]) => {
				this.targetServiceLevelData = (res || []).map((e) => e.listElement);
			});
		// refreshTheme();
	}

	getFiltersData() {
		throw new Error('Method not implemented.');
	}
	getForecastValdata(arg0: string) {
		throw new Error('Method not implemented.');
	}
	initFilterOptions() {
		throw new Error('Method not implemented.');
	}

	canEdit(columnName: string): boolean {
		return !!this._editableColumns[columnName];
	}

	getDataType(columnName: string, column: any): string {
		return this._editableColumns[columnName] || column.dataType || "string";
	}

	onRowUpdated(event) {
		if (event.key.ProductId) {
			this.hasDirty = true;
			this.gridData = this.gridData.map((item) =>
				item.ProductId === event.key.ProductId
					? { ...item, IsDirty: true }
					: item
			);
		}
	}

	onSaveChanges() {
		const changedItems = this.gridData
			.filter((i) => i.IsDirty)
			.map<DecisionTreeManualDto>((item) => ({
				productId: item.ProductId,
				comment: item.Comment as string,
				safetyStockManual: item.SafetyStockManual as number,
				serviceLevelManual: item.ServiceLevelManual as string,
			}));

		if (changedItems.length > 0) {
			this.esoService.SaveDecisionTreeManuals(changedItems).subscribe((res) => {
				this.infoBoxService.show({
					message: "Data has been successfully saved!",
				});

				if (this.dataGrid && this.dataGrid.instance) {
					this.gridFilterState = this.dataGrid.instance.getCombinedFilter();
					this.filterRowState = {};
					this.headerFiltersState = {};
					this.sortOrderState = {};
					this.dataGrid.instance.getVisibleColumns().forEach((col: any) => {
						if (col.dataField) {
							if (col.sortOrder) { // If the column has a sort order ('asc' or 'desc')
								this.sortOrderState[col.dataField] = col.sortOrder; // Store sort order only
							}
							if (col.filterValue) {
								this.filterRowState[col.dataField] = {
									filterValue: col.filterValue,
								};
							}
							if (col.filterValues && col.filterValues.length > 0) {
								this.headerFiltersState[col.dataField] = [...col.filterValues];
							}
						}
					});
				}


				this.dataGrid.instance.closeEditCell();
				this.hasDirty = false;
				this.getData();
				//this.EsoOverviewGridDataOperator.load(
				///	{
				//		showLoadingIndicator: true
				//	}
				//);
				this.ChartDataOperator.load(
					{
						showLoadingIndicator: true
					}
				);
				//this.StockChartDataOperator.load(
				//	{
				//		showLoadingIndicator: true
				//	}
				//);
			});
		}
	}

	onUndoGrid() {
		if (this.hasDirty) {
			this.dataGrid.instance.beginCustomLoading('Reverting changes');
			this.dataGrid.instance.closeEditCell();
			this.loadGrid();
			this.hasDirty = false;
			this.dataGrid.instance.endCustomLoading();
		}
	}

	onReset() {
		this.getData();
		//this.EsoOverviewGridDataOperator.load(
		//	{
		//		showLoadingIndicator: true
		//	}
		//);
		this.ChartDataOperator.load(
			{
				showLoadingIndicator: true
			}
		);

		//this.StockChartDataOperator.load(
		//	{
		//	showLoadingIndicator: true
		//	}
		//);

	}

	onResize = () => {
		setTimeout(() => {
			this.dxStockValueChart.instance.refresh();
			this.changeCount.instance.refresh();
			this.LoadChartSeries();
		});
	};
	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	}

	goToDeepDive(data: any) {
		if (!data.ProductId) {
			return;
		}
		this.windowService.openInNewPage("/eso/deep-dive", {
			productId: data.ProductId,
		});
	}

	customizeText = (info: any) => {
		return `${info.argumentText}/${info.value}/${info.percentText}`;
	};

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "gridActions",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'before',
			template: 'saveTemplate'
		}, {
			location: 'before',
			template: 'discardTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		});
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;
		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	private getData() {
		this.filterOptions = new OverviewFiltersOutput();
		this.filterOptions.action = this.action;
		this.filterOptions.settingGroupId = 1;
		this.filterOptions.filters = [];
		if (this.pageFiltersOperator.overviewFiltersOutput.filters) {
			this.pageFiltersOperator.overviewFiltersOutput.filters.forEach(element => {
				let filterItem: QueryFilterParameter = new QueryFilterParameter(
					element.fieldName,
					element.value,
					element.operation
				);
				this.filterOptions.filters.push(filterItem);
			});
		}
		// this.esoService
		// 	.getEsoOverviewData(this.filterOptions.action, this.filterOptions.filters)
		// 	.subscribe(
		// 		(res) => {
		// 			this.hasDirty = false;
		// 			this.changeCountChartData = res.changeCountChartData || [];
		// 			this.stockValueChartData = res.stockValueChartData || [];
		// 			this.gridColumns = [];

		// 			if (res != null && res.gridData.columns != null) {
		// 				for (var i = 0; i < res.gridData.columns.length; i++) {
		// 					var dataTypeValue = "string";
		// 					if (this.SettingDecimal != null && this.SettingDecimal.length > 0) {
		// 						var itemFilter = this.SettingDecimal.find(x => x.name == res.gridData.columns[i].columnName);
		// 						if (itemFilter != null) {
		// 							dataTypeValue = "number";
		// 						}
		// 					}
		// 					this.gridColumns.push({
		// 						caption: res.gridData.columns[i].caption,
		// 						columnName: res.gridData.columns[i].columnName,
		// 						dataType: dataTypeValue
		// 					})
		// 				}
		// 			}
		// 			this.gridData = res.gridData.data;
		// 			this.dataLoaded = true;

		// 			if (this.dataGrid && this.gridFilterState) {
		// 				this.dataGrid.instance.filter(this.gridFilterState);
		// 			}

		// 			setTimeout(() => {
		// 				this.LoadChartSeries();
		// 			}, 1000);
		// 		},
		// 		(err) => {
		// 			this.notificationService.error(err.message);
		// 			console.log(err);
		// 		}
		// 	);

		this.StockChartDataOperator
			.getObservable(
				{
					showLoadingIndicator: true,
				},
				new SelectStatementOptions({
					baseSelectStatementId: BaseSelectStatementId.EsoOverviewStockValueChart,
					selectionSetId: null,
					filters: this.pageFiltersOperator.appliedFilters,

				})
			)
			.then((promiseResponse) => {
				promiseResponse.subscribe({
					next: (res) => {
						const pivotedData = res.data.flatMap(item => {
							return Object.entries(item).map(([key, value]) => ({
								name: key,
								value: value
							}));
						});
						this.stockValueChartData = pivotedData || [];
						console.log('Pivoted Stockdata', this.stockValueChartData);
					},
				});
			});

		this.loadGrid();


	}

	loadGrid() {
		this.EsoOverviewGridDataOperator
			.getObservable(
				{
					showLoadingIndicator: true,
				},
				new SelectStatementOptions({
					baseSelectStatementId: BaseSelectStatementId.EsoOverviewGridData,
					selectionSetId: SelectionSetId.EsoOverviewList,
					filters: this.pageFiltersOperator.appliedFilters,

				})
			)
			.then((promiseResponse) => {
				promiseResponse.subscribe({
					next: (res) => {
						this.gridColumns = [];
						if (res != null && res.columns != null) {
							for (var i = 0; i < res.columns.length; i++) {
								var dataTypeValue = "string";
								if (this.SettingDecimal != null && this.SettingDecimal.length > 0) {
									var itemFilter = this.SettingDecimal.find(x => x.name == res.columns[i].columnName);
									if (itemFilter != null) {
										dataTypeValue = "number";
									}
								}
								this.gridColumns.push({
									caption: res.columns[i].caption,
									columnName: res.columns[i].columnName,
									dataType: dataTypeValue
								})
							}
						}
						this.gridData = res.data;
						this.dataLoaded = true;
						// Restore configuration after data is loaded
						setTimeout(() => this.restoreFilterUIState(), 0);
						// if (this.dataGrid && this.gridFilterState) {
						// 	this.dataGrid.instance.filter(this.gridFilterState);
						// 	this.gridFilterState = null; 
						// }
						console.log('Pivoted Stockdata', this.stockValueChartData);
					},
				});
			});

	}

	/* Export Forecast Option */
	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportEsoOverview").subscribe(resultFilename => {
			this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
		this.fileExportService.WebSettings("EnableExportEsoOverviewlist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotEsoOverview").subscribe(result => {
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipEsoOverview != null
				&& result[0].defaultSelectionTooltipEsoOverview.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipEsoOverview != null
				&& result[0].enableDisableTooltipEsoOverview.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}
			this.EsoOverviewDeepDiveDecimalPlace = (result[0].esoOverviewDeepDiveDecimalPlace != null && result[0].esoOverviewDeepDiveDecimalPlace != 0 ? result[0].esoOverviewDeepDiveDecimalPlace : 0)

		}, err => {
			console.log(err);
		});
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}
	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	//hide and show series on click
	pointClickHandler(e) {
		this.toggleVisibility(e.target);
	}

	legendClickHandler(e) {
		const arg = e.target;
		const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
		this.toggleVisibility(item);
	}

	toggleVisibility(item) {
		if (item.isVisible()) {
			item.hide();
		} else {
			item.show();
		}
		this.loadLengendToShare();
	}

	anyScopeTableActiveFilters = false;
	changeScopeTableActiveFiltersStatus() {
		if (this.anyScopeTableActiveFilters) {
			this.anyScopeTableActiveFilters = !this.anyScopeTableActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			if (this.ChartSettings) {
				this.ChartSettings.ScopeList = [];
			}
			this.gridFilterState = null;
			this.headerFiltersState = {};
			this.filterRowState = {};
			this.dataGrid.instance.clearSorting();
			this.sortOrderState = {};
		}
	}

	onDataGridCellPrepared(e) {
	}

	loadLengendToShare() {
		var seriesValues = { DevelopmentChart: [], ScopeList: [] };
		if (this.changeCount != null && this.changeCount.instance != null
			&& this.changeCount.instance.getAllSeries() != null
			&& this.changeCount.instance.getAllSeries()[0] != null
			&& this.changeCount.instance.getAllSeries()[0].getAllPoints() != null
			&& this.changeCount.instance.getAllSeries()[0].getAllPoints().length > 0
		) {
			for (let index = 0; index < this.changeCount.instance.getAllSeries()[0].getAllPoints().length; index++) {
				var item = this.changeCount.instance.getAllSeries()[0].getAllPoints()[index];
				if (item["argument"] != null && item["isVisible"]() != null) {
					seriesValues.DevelopmentChart.push({ ValueField: item["argument"], Name: item["argument"], isVisible: item["isVisible"]() });
				}
			}
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {
		if (this.changeCount != null && this.changeCount.series != null
			&& Array.isArray(this.changeCount.series) && this.changeCount.series.length > 0) {
			for (let index = 0; index < this.changeCount.series.length; index++) {
				this.changeCount.series[index]["visible"] = true;
			}
		}
		if (this.ChartSettings != null) {
			if (this.ChartSettings.DevelopmentChart != null && this.ChartSettings.DevelopmentChart.length > 0) {
				if (this.changeCount != null && this.changeCount.instance != null
					&& this.changeCount.instance["series"] != null && this.changeCount.instance["series"][0] != null
					&& this.changeCount.instance["series"][0].getPoints() != null && this.changeCount.instance["series"][0].getPoints().length != null
				) {
					for (let index = 0; index < this.changeCount.instance["series"][0].getPoints().length; index++) {
						this.ChartSettings.DevelopmentChart.forEach(itemchrt => {
							if (this.changeCount.instance["series"][0].getPoints()[index].argument != null
								&& itemchrt.isVisible != null
								&& (this.changeCount.instance["series"][0].getPoints()[index].argument.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.changeCount.instance["series"][0].getPoints()[index].argument.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								if (itemchrt.isVisible) {
									this.changeCount.instance["series"][0].getPoints()[index].show();
								}
								else {
									this.changeCount.instance["series"][0].getPoints()[index].hide();
								}
							}
						});
					}
				}
			}

			// if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
			// 	if (this.dataGrid != null && this.dataGrid.instance != null) {
			// 		this.ChartSettings.ScopeList.forEach(element => {
			// 			this.dataGrid.instance.beginUpdate();
			// 			this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
			// 			if (element.filterType != null && element.filterType != undefined) {
			// 				this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
			// 			}
			// 			this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
			// 			this.dataGrid.instance.endUpdate();
			// 		});
			// 	}
			// }


		}
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyScopeTableActiveFilters = true;
		} else {
			this.anyScopeTableActiveFilters = false;
		}
		this.dxDataGridOperator.updateRowCount(evt.component);
		//localStorage.setItem('grid-state-eso-overview', JSON.stringify(this.dataGrid.instance.state())); 
	}

	onGridOptionChanged(evt) {
		if (evt.fullName && evt.fullName.includes('sortOrder')) {
			const match = evt.fullName.match(/columns\[(\d+)]/);
			const columnIndex = match ? parseInt(match[1], 10) : null;

			if (columnIndex !== null) {
				const col = evt.component.getVisibleColumns()[columnIndex];

				if (col) {
					if (evt.value === 'asc' || evt.value === 'desc') {
						this.sortOrderState[col.dataField] = evt.value;
					} else if (!evt.value || evt.value === 0) {
						delete this.sortOrderState[col.dataField];
					}
				}
			}
		}
	}

	restoreFilterUIState() {
		if (!this.dataGrid || !this.dataGrid.instance) return;

		// Use beginUpdate/endUpdate to batch column changes
		this.dataGrid.instance.beginUpdate();

		try {
			// Restore filter row values
			Object.keys(this.filterRowState).forEach(field => {
				const filter = this.filterRowState[field];
				this.dataGrid.instance.columnOption(field, 'filterValue', filter.filterValue);
			});

			// Restore header filter values
			Object.keys(this.headerFiltersState).forEach(field => {
				const filterValues = this.headerFiltersState[field];
				if (filterValues && filterValues.length > 0) {
					this.dataGrid.instance.columnOption(field, 'filterValues', filterValues);

				}
			}); 
			// Restore sort order
			Object.keys(this.sortOrderState).forEach(field => {
				const fsortOrderalues = this.sortOrderState[field];
				console.log('fsortOrderalues', fsortOrderalues);
				this.dataGrid.instance.columnOption(field, 'sortOrder', fsortOrderalues);
				this.dataGrid.instance.columnOption(field, 'sortIndex', 0);
			});

		} finally {
			this.dataGrid.instance.endUpdate();
		}

		// Clear the states - use empty objects instead of arrays
		this.filterRowState = {};
		this.headerFiltersState = {};
		this.sortOrderState = {};
	}
}
